import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

import { AddEmailBanner } from "../components/add-email";
import { Logo } from "../components/logo";
import { authApi } from "../lib/api";
import { requireSession, viewerQuery } from "../lib/session";

export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context, location }) => requireSession(context.queryClient, location.href),
  component: AppLayout,
});

function AppLayout() {
  const queryClient = useQueryClient();
  const viewer = useQuery(viewerQuery);

  const logout = useMutation({
    mutationFn: authApi.logout,
    // Clear every cached query on sign-out: leaving one user's data in the cache is how the
    // next person to use the browser sees it.
    onSuccess: () => {
      queryClient.clear();
      window.location.href = "/";
    },
  });

  return (
    <div className="min-h-dvh">
      <header className="border-b-2 border-line bg-surface">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <Logo to="/mes-listes" />
          <nav className="flex items-center gap-1">
            <Link
              to="/mes-listes"
              className="btn-ghost hidden sm:inline-flex"
              activeOptions={{ exact: true }}
              activeProps={{ className: "bg-ink/5" }}
            >
              Mes listes
            </Link>
            <Link to="/idees-cadeaux" className="btn-ghost hidden sm:inline-flex">
              Idées cadeaux
            </Link>
            {viewer.data?.user.isAdmin && (
              <Link to="/admin" className="btn-ghost hidden sm:inline-flex">
                Admin
              </Link>
            )}
            <Link
              to="/mon-compte"
              className="btn-ghost"
              activeProps={{ className: "bg-ink/5" }}
              title={viewer.data?.user.email ?? undefined}
            >
              Mon compte
            </Link>
            <button
              type="button"
              className="btn-ghost"
              onClick={() => logout.mutate()}
              disabled={logout.isPending}
              title={viewer.data?.user.email ?? undefined}
            >
              Déconnexion
            </button>
          </nav>
        </div>
      </header>
      {viewer.data?.user.isGuest && (
        <div className="mx-auto max-w-6xl px-4 pt-4 sm:px-6">
          <AddEmailBanner />
        </div>
      )}
      <main>
        <Outlet />
      </main>
    </div>
  );
}
